import React, { useEffect, useState } from "react";
import BienvenidoAdmin from "../../components/administracion/BienvenidoAdmin";
import TituloPagina from "../../components/comunes/TituloPagina";
import Footer from "../../components/comunes/Footer";
import TablaTerminalesExcepcionAnticipo from "../../components/administracion/TablaTerminalesExcepcionAnticipo";
import { getToken } from "../../utils/auth";


const toInputDate = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "";
    return d.toISOString().slice(0, 10);
};

const todayInput = () => {
    const d = new Date();
    return d.toISOString().slice(0, 10);
};

const normalize = (item) => ({
    id: item.id ?? item.Id,
    nroTerminal: item.nroTerminal ?? item.NroTerminal,
    fechaAlta: item.fechaAlta ?? item.FechaAlta,
    fechaBaja: item.fechaBaja ?? item.FechaBaja,
    estaEliminado: item.estaEliminado ?? item.EstaEliminado
});

const AdminTerminalesExcepcionAnticipo = () => {
    const [data, setData] = useState([]);
    const [loadingTabla, setLoadingTabla] = useState(false);
    const [error, setError] = useState("");

    const [mostrarForm, setMostrarForm] = useState(false);
    const [modo, setModo] = useState("crear"); // crear | editar
    const [form, setForm] = useState({
        id: 0,
        nroTerminal: "",
        fechaAlta: "",
        fechaBaja: ""
    });

    const token = getToken();

    const cargar = async () => {
        setLoadingTabla(true);
        setError("");
        try {
            const res = await fetch(process.env.REACT_APP_API_TERM_EXCEP_LISTAR, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ Token: token, IncluirEliminados: false })
            });
            if (!res.ok) throw new Error("Error al listar");
            const json = await res.json();
            const mapped = (Array.isArray(json) ? json : []).map(normalize);
            setData(mapped);
        } catch (e) {
            setError(e.message || "Error al listar");
            setData([]);
        } finally {
            setLoadingTabla(false);
        }
    };

    useEffect(() => {
        if (token) {
            cargar();
        } else {
            setError("Token no encontrado");
        }
    }, []);

    const abrirCrear = () => {
        setModo("crear");
        setForm({
            id: 0,
            nroTerminal: "",
            fechaAlta: todayInput(),
            fechaBaja: ""
        });
        setMostrarForm(true);
    };

    const abrirEditar = (item) => {
        setModo("editar");
        setForm({
            id: item.id,
            nroTerminal: item.nroTerminal ?? "",
            fechaAlta: toInputDate(item.fechaAlta),
            fechaBaja: toInputDate(item.fechaBaja)
        });
        setMostrarForm(true);
    };

    const cerrarForm = () => {
        setMostrarForm(false);
    };

    const guardar = async () => {
        setError("");
        try {
            if (!form.nroTerminal.trim()) {
                setError("El número de terminal es obligatorio");
                return;
            }

            const nroTerminalNum = Number(form.nroTerminal);
            if (Number.isNaN(nroTerminalNum) || nroTerminalNum <= 0) {
                setError("Número de terminal inválido");
                return;
            }

            if (modo === "crear") {
                const res = await fetch(process.env.REACT_APP_API_TERM_EXCEP_CREAR, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        Token: token,
                        NroTerminal: nroTerminalNum,
                        FechaAlta: form.fechaAlta ? form.fechaAlta : null
                    })
                });
                if (!res.ok) throw new Error("Error al crear");
            } else {
                const res = await fetch(process.env.REACT_APP_API_TERM_EXCEP_EDITAR, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        Token: token,
                        Id: form.id,
                        NroTerminal: nroTerminalNum,
                        FechaAlta: form.fechaAlta ? form.fechaAlta : null,
                        FechaBaja: form.fechaBaja ? form.fechaBaja : null
                    })
                });
                if (!res.ok) throw new Error("Error al editar");
            }

            setMostrarForm(false);
            await cargar();
        } catch (e) {
            setError(e.message || "Error al guardar");
        }
    };

    const eliminar = async (item) => {
        const ok = window.confirm(`¿Eliminar la terminal ${item.nroTerminal}?`);
        if (!ok) return;

        setError("");
        try {
            const res = await fetch(process.env.REACT_APP_API_TERM_EXCEP_ELIMINAR, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ Token: token, Id: item.id })
            });
            if (!res.ok) throw new Error("Error al eliminar");
            await cargar();
        } catch (e) {
            setError(e.message || "Error al eliminar");
        }
    };

    return (
        <div translate="no" className="d-flex flex-column min-vh-100">
            <div className="pt-5">
                <BienvenidoAdmin />
            </div>
            <div>
                <TituloPagina title="Terminales Excepción Anticipo" />
            </div>

            <div className="py-4 container">
                <div className="d-flex flex-wrap align-items-center gap-3 mb-3">
                    <button className="btn btn-dark" onClick={abrirCrear}>
                        Agregar terminal
                    </button>
                </div>

                {mostrarForm && (
                    <div className="bg-light p-3 rounded mb-3">
                        <div className="d-flex flex-wrap gap-3 align-items-end">
                            <div className="d-flex flex-column">
                                <label className="fs-12 lato-regular">Nro Terminal</label>
                                <input
                                    className="form-control"
                                    type="number"
                                    value={form.nroTerminal}
                                    onChange={(e) => setForm({ ...form, nroTerminal: e.target.value })}
                                />
                            </div>

                            <div className="d-flex flex-column">
                                <label className="fs-12 lato-regular">Fecha Alta</label>
                                <input
                                    className="form-control"
                                    type="date"
                                    value={form.fechaAlta}
                                    onChange={(e) => setForm({ ...form, fechaAlta: e.target.value })}
                                />
                            </div>

                            <div className="d-flex flex-column">
                                <label className="fs-12 lato-regular">Fecha Baja</label>
                                <input
                                    className="form-control"
                                    type="date"
                                    value={form.fechaBaja}
                                    onChange={(e) => setForm({ ...form, fechaBaja: e.target.value })}
                                />
                            </div>

                            <div className="d-flex gap-2">
                                <button className="btn btn-dark" onClick={guardar}>
                                    {modo === "crear" ? "Guardar" : "Actualizar"}
                                </button>
                                <button className="btn btn-outline-dark" onClick={cerrarForm}>
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                <TablaTerminalesExcepcionAnticipo
                    data={data}
                    loading={loadingTabla}
                    error={error}
                    onEdit={abrirEditar}
                    onDelete={eliminar}
                />
            </div>

            <div className="py-4 mt-auto">
                <Footer />
            </div>
        </div>
    );
};

export default AdminTerminalesExcepcionAnticipo;
